import { css } from "@emotion/core";
import { color, fontTypes } from "../../constants/commons";
import { Status } from "./interface";

export const displayInfoStyles = (status: Status, isMobile?: boolean) => css`
  margin-bottom: 1em;
  .info-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 15px;
    color: ${color.lightishGray};
    font-family: ${fontTypes.bodyFont};
  }
  .info-box {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 15px;
    ${!isMobile && `text-align: center;`}
  }
  .info-box-icon {
    margin-right: 1em;
    margin-top: 2px;
    align-self: baseline;
  }
  .info-box-data {
    display: flex;
    flex-direction: column;
    .title {
      display: flex;
      ${!isMobile && `justify-content: center;`}
      font-family: ${fontTypes.meduim};
      font-weight: 500;
      line-height: 1.5em;
      .title-array {
        display: flex;
        flex-direction: column;
      }
      .title-action-link {
        text-transform: none;
        word-break: break-all;
      }
    }
    .description {
      display: flex;
      flex-direction: column;
      color: ${color.lightishGray};
      font-family: ${fontTypes.bodyFont};
      font-weight: normal;
    }
  }

  ${isMobile
    ? `width: 90%;
    .info-box {
      justify-content: flex-start;
    }`
    : `width: 60%;
    .info-box {
      justify-content: center;
      align-items: center;
    }`}

  ${status === Status.pending &&
  `.info-box {
    background: ${color.ligitishYellowShadow};
    border: 1px solid ${color.yellow};
    .title {
      color: ${color.yellow};
    }
  }`}

  ${status === Status.success &&
  `.info-box {
    background: ${color.ligitishGreenShadow};
    border: 1px solid ${color.green};
    .title {
      color: ${color.green};
    }
  }`}

  ${(status === Status.error || status === Status.warning) &&
  `.info-box {
    background: ${color.ligitishOrangeShadow};
    border: 1px solid ${color.orange};
    .title {
      color: ${color.orange};
    }
  }`}

  ${status === Status.inProgress &&
  `.info-box {
    background: ${color.lightishGrayShadow};
    border: 1px solid ${color.lightishGray};
    .title {
      color: ${color.lightishGray};
    }
  }`}
  
  ${status === Status.default &&
  `.info-box {
    background: ${color.white};
    border: none;
    .title {
      color: ${color.red};
    }
  }`}
`;
